/** Стабильная подпись query без cursor для сброса пагинации при смене фильтров. */
export const serializeReconciliationQuery = (query: Record<string, unknown>): string => {
  const entries = Object.entries(query)
    .filter(([key, value]) => key !== 'cursor' && value !== undefined && value !== '')
    .sort(([a], [b]) => a.localeCompare(b));
  return JSON.stringify(entries);
};

export const RECONCILIATION_LIST_PAGE_SIZE = 50;
